import Card from "../../Components/Card";
import "./style.css";
import facebook from "../../assets/Mask Group 2.png";
import youtube from "../../assets/Mask Group 3.png";
import savan from "../../assets/Mask Group 1.png";
import ContectUs from "../../Templates/Common/ContactUs";

function DigitalSection() {
    const data = [["Category", [["Automobile (345)"],["Business (45)"],["ECommerse (345)"],["Education (443)"]]], ["Media Options", [["Push Notifications"],["Social media post"],["Stories"],["Text AD"]]], ["Targeting Filters", [["Age"],["Custom Audience"],["Gender"],["Language"]]], ["Pricing Model", [["CPC"],["Fixed"]]],]

    return (
        <>
            <div className=" mx-auto container grid lg:grid-cols-12 grid-cols-1  gap-10 pt-10 pb-10 pl-5 pr-5">
                <div className="hidden lg:block col-span-4 xl:col-span-3 2xl:col-span-2">
                    <h1 className="text-2xl font-bold mb-7">Filters</h1>
                    <div style={{backgroundColor: "rgba(207,16,45,0.1)"}} className="p-5 rounded-xl">
                        {data.map((item, i) => {
                            return <Item data={data[i]} /> 
                        })}
                    </div>
                </div>
                <div className=" col-span-1 lg:col-span-8 xl:col-span-9 2xl:col-span-10">
                    <div className="text-center font-bold text-2xl">Digital apps</div>
                    <div className="flex justify-between font-semibold mb-6 mt-6">
                        <p>3456 Results Found</p>
                        <p className="top-secrate">Top Searched</p>
                    </div>
                    <div className="flex flex-wrap gap-3 justify-center">
                        <Card imgLink={facebook} text="Facebook, App"/>
                        <Card imgLink={youtube} text="Youtube, App"/>
                        <Card imgLink={savan} text="Jio Saavan, App"/>
                        <Card imgLink={facebook} text="Facebook, App"/>
                        <Card imgLink={youtube} text="Youtube, App"/>
                        <Card imgLink={savan} text="Jio Saavan, App"/>
                        <Card imgLink={facebook} text="Facebook, App"/>
                        <Card imgLink={youtube} text="Youtube, App"/>
                        <Card imgLink={savan} text="Jio Saavan, App"/>
                        <Card imgLink={facebook} text="Facebook, App"/>
                        <Card imgLink={youtube} text="Youtube, App"/>
                        <Card imgLink={savan} text="Jio Saavan, App"/>
                        <Card imgLink={facebook} text="Facebook, App"/>
                        <Card imgLink={youtube} text="Youtube, App"/>
                        <Card imgLink={savan} text="Jio Saavan, App"/>
                    </div>
                </div>
            </div>
            <ContectUs />
        </>
    )
}

function Item({data}) {
    return (
        <div className="mb-3">
            <h3 className="font-bold text-lg mb-3">{data[0]}</h3>
                {data[1].map((item, i) => {
                    return (
                        <div className="flex justify-between items-center">
                            <h4 className="text-base font-semibold bg-transparent">{data[1][i]}</h4>
                            <input className="radio-button-style" name={data[0]} type="radio" />
                        </div>)
                })}
                <div className="see-more font-medium mt-2">See more</div>
        </div>
    )
}

export default DigitalSection